import { render } from "./SubCategory.vue?vue&type=template&id=58c7c106&scoped=true"
import script from "./SubCategory.vue?vue&type=script&lang=js"
export * from "./SubCategory.vue?vue&type=script&lang=js"

import "./SubCategory.vue?vue&type=style&index=0&id=58c7c106&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58c7c106"]])

export default __exports__